import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSIndeterminateProgressIndicator from '@elliemae/ds-basic/IndeterminateProgressIndicator';

/* eslint-disable react/no-unused-state */
var blockName = 'shuttle-infinite-scroll-indicator';
var InfiniteScrollBarContainer = aggregatedClasses('div')(blockName, null, function (_ref) {
  var isOpen = _ref.isOpen;
  return {
    opened: isOpen
  };
});

var ShuttleInfiniteScrollIndicator = function ShuttleInfiniteScrollIndicator(_ref2) {
  var isOpen = _ref2.isOpen;
  return /*#__PURE__*/React.createElement(InfiniteScrollBarContainer, {
    classProps: {
      isOpen: isOpen
    },
    "data-testid": blockName
  }, /*#__PURE__*/React.createElement(DSIndeterminateProgressIndicator, {
    processing: true,
    title: "Loading"
  }));
};

export default ShuttleInfiniteScrollIndicator;
//# sourceMappingURL=ShuttleInfiniteScrollIndicator.js.map
